<app-loader *ngIf="!isPageReady"></app-loader>
<form *ngIf="isPageReady" method="post" [formGroup]="userForm">
  <div class="col-6">
    <div>
      <div class="form-group">
        <label for="title">Titulus</label>
        <input type="text" id="title" class="form-control" formControlName="title" maxlength="50" />
        <div *ngIf="title.invalid && (title.dirty || title.touched)" class="alert alert-danger">
          <div *ngIf="title.errors?.['maxlength']">A titulus legfeljebb 50 karakter lehet.</div>
          <div *ngIf="title.errors?.['serverError']">{{title.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group">
        <label>Vezetéknév<span class="required-label" *ngIf="surname.errors?.['required']">*</span></label>
        <input type="text" id="surname" class="form-control" formControlName="surname" maxlength="50" />
        <div *ngIf="surname.invalid && (surname.dirty || surname.touched)" class="alert alert-danger">
          <div *ngIf="surname.errors?.['required']">A vezetéknév kötelező.</div>
          <div *ngIf="surname.errors?.['maxlength']">A vezetéknév legfeljebb 50 karakter lehet.</div>
          <div *ngIf="surname.errors?.['serverError']">{{surname.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group">
        <label>Keresztnév<span class="required-label" *ngIf="forename.errors?.['required']">*</span></label>
        <input type="text" id="forename" class="form-control" formControlName="forename" maxlength="50" />
        <div *ngIf="forename.invalid && (forename.dirty || forename.touched)" class="alert alert-danger">
          <div *ngIf="forename.errors?.['required']">A keresztnév kötelező.</div>
          <div *ngIf="forename.errors?.['maxlength']">A keresztnév legfeljebb 50 karakter lehet.</div>
          <div *ngIf="forename.errors?.['serverError']">{{forename.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group">
        <label>Keresztnév 2</label>
        <input type="text" id="forename2" class="form-control" formControlName="forename2" maxlength="50" />
        <div *ngIf="forename2.invalid && (forename2.dirty || forename2.touched)" class="alert alert-danger">
          <div *ngIf="forename2.errors?.['maxlength']">A 2. keresztnév legfeljebb 50 karakter lehet.</div>
          <div *ngIf="forename2.errors?.['serverError']">{{forename2.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group">
        <label for="email">Email<span class="required-label" *ngIf="email.errors?.['required']">*</span></label>
        <input type="text" id="email" class="form-control" formControlName="email" maxlength="50" required />
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
          <div *ngIf="email.errors?.['pattern']">Nem megfelelő email formátum.</div>
          <div *ngIf="email.errors?.['minlength']">Az email-nek legalább 5 karakter hosszúnak kell lennie.</div>
          <div *ngIf="email.errors?.['required']">Az email kötelező.</div>
          <div *ngIf="email.errors?.['maxlength']">Az email legfeljebb 50 karakter lehet.</div>
          <div *ngIf="email.errors?.['serverError']">{{email.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group">
        <label>Okmányazonosító szám</label>
        <input type="text" id="idNumber" class="form-control" formControlName="idNumber" maxlength="100" />
        <div *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)" class="alert alert-danger">
          <div *ngIf="idNumber.errors?.['maxlength']">Az okmányazonosító szám legfeljebb 100 karakter lehet.</div>
        </div>
      </div>

      <div class="form-group">
        <label>Szerepkör<span class="required-label" *ngIf="roles.errors?.['required']">*</span></label>
        <ng-select
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Kérem válasszon szerepkört!"
          notFoundText="Nincs találat!"
          formControlName="roles">
          <ng-option *ngFor="let option of roleSelectList.items" [value]="option.value">
            {{ option.text }}
          </ng-option>
        </ng-select>
        <div *ngIf="roles.invalid && (roles.dirty || roles.touched)" class="alert alert-danger">
          <div *ngIf="roles.errors?.['required']">A szerepkört kötelező megadni.</div>
          <div *ngIf="roles.errors?.['serverError']">{{roles.errors?.['serverError']}}</div>
        </div>
      </div>

      <div class="form-group" *ngIf="isPageReady">
        <label>Terület<span class="required-label" *ngIf="tenant.errors?.['required']">*</span></label>
        <ng-select
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Kérem válasszon legalább egy területet!"
          notFoundText="Nincs találat!"
          formControlName="tenantIds"
        >
          <ng-option *ngFor="let option of tenantSelectList.items" [value]="option.value">
            {{ option.text }}
          </ng-option>
        </ng-select>
        <div *ngIf="tenant.invalid && (tenant.dirty || tenant.touched)" class="alert alert-danger">
          <div *ngIf="tenant.errors?.['required']">Legalább egy területet kötelező megadni.</div>
          <div *ngIf="tenant.errors?.['serverError']">{{tenant.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-check">
        <input id="twoFactorEnabled" type="checkbox" class="form-check-input"
               [checked]="twoFactorEnabled.value" formControlName="twoFactorEnabled" />
        <label for="twoFactorEnabled">Két lépcsős azonosítás</label>
      </div>
    </div>
  </div>
  <div class="button-group">
    <button (click)="onSubmit()" class="btn btn-primary text-white btn-save me-2" [disabled]="userForm.invalid">
      Mentés
    </button>
    <a
      (click)="onGoBack('/users')"
      class="btn btn-dark">
      Vissza
    </a>
  </div>
</form>
